import STRINGS from './strings';

const useTranslation = () => {
    const trans = (key, ...params) => {
        let text = STRINGS[key] || key;
        if (params.length) {
            params.forEach(param => {
                text = text.replace(
                    `<${Object.keys(param)[0]}>`,
                    Object.values(param)[0],
                );
            });
        }
        return text;
    };
    return trans;
};

export default useTranslation;
